import { GlobalContext } from "../../../../utils/globalprovider.js";

import SimplePopup from "../../../../components/bases/popup/simplePopup.js";
import Button from "../../../../components/bases/button/button.js";
import { getColorByShortcut } from "../../../../utils/colors.js";
import imgDelete from './assets/delete.png';
import imgEdit from './assets/edit.png';
import imgAdd from './assets/plus.png';
import imgMerge from './assets/merge.png';
import imgEye from './assets/eye.png';
import CommonSpeakerForm from "./commonspeakerform/commonspeakerform.js";
import CommonMergeSpeakerForm from './commonmergeform/commonmergeform.js';

import React from "react";
import './speakerslist.css';
import { last, orderBy } from 'lodash';

class SpeakersList extends React.Component {
  static contextType = GlobalContext;

  constructor(props) {
    super(props);

    this.state = {
      speakerForm: {
        displayed: false,
        title: null,
        speaker: null,
      },
      mergeForm: {
        displayed: false,
        title: null,
        speaker: null,
        speakers: [],
      },
      popup: {
        displayed: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
      width: 0,
      height: 0
    };

    this.resizeObserver = null;

    this.onShowEditSpeakerFormDialog =
      this.onShowEditSpeakerFormDialog.bind(this);
    this.onShowAddSpeakerFromDialog =
      this.onShowAddSpeakerFromDialog.bind(this);
    this.onShowMergeSpeakerFormDialog =
      this.onShowMergeSpeakerFormDialog.bind(this);
    this.onClickCommonSpeakerForm = this.onClickCommonSpeakerForm.bind(this);
    this.onClickCommonMergeForm = this.onClickCommonMergeForm.bind(this);
    this.onIdentifySpeakerDialoguesClick = this.onIdentifySpeakerDialoguesClick.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onConfirmDeleteSpeaker = this.onConfirmDeleteSpeaker.bind(this);
    this.onChangeSpeakers = this.onChangeSpeakers.bind(this);

    this.speakerFormRef = React.createRef();
    this.mergeFormRef = React.createRef();
  }

  componentDidMount() {
    // Crée un ResizeObserver
    const div = document.querySelector('#speakersDiv').parentElement;

    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        this.setState({ width, height });

      }
    });

    // Observer les changements de taille de la div du foreCanvas
    this.resizeObserver.observe(div);
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
  }

  onShowEditSpeakerFormDialog(speaker) {
    const names = [];

    if (speaker.firstName) {
      names.push(speaker.firstName);
    }

    if (speaker.name) {
      names.push(speaker.name);
    }

    const label = names.join(' ');

    const title = {
      fr: `Modifier ${label}`,
      en: `Edit ${label}`,
    };

    this.setState({
      speakerForm: {
        displayed: true,
        title,
        speaker,
      },
    });
  }

  onShowMergeSpeakerFormDialog(speaker) {
    const names = [];

    if (speaker.firstname) {
      names.push(speaker.firstName);
    }

    if (speaker.name) {
      names.push(speaker.name);
    }

    const label = names.join(' ');

    const title = {
      fr: `Fusionner ${label} avec un autre speaker ?`,
      en: `Merge ${label} with an another speaker?`,
    };

    this.setState({
      mergeForm: {
        displayed: true,
        title,
        speaker,
        speakers: this.props.speakers.filter((x) => x.id !== speaker.id),
      },
    });
  }

  onShowAddSpeakerFromDialog() {
    const title = {
      fr: `Ajouter un nouveau speaker`,
      en: `Add a new speaker`,
    };

    this.setState({
      speakerForm: {
        displayed: true,
        title,
        speaker: {
          id: undefined,
          firstname: '',
          name: '',
          job: '',
          gender: null,
          picture: null,
          color: null,
        },
      },
    });
  }

  onAddSpeaker(speaker) {
    
    const speakers = orderBy([...this.props.speakers], (x) =>
      parseInt(x.id.replace(/\D/g, ''), 10)
    );

    const lastId = speakers.length
      ? parseInt(last(speakers).id.toString().replace(/\D/g, ''))
      : 0;
    speaker.id = 'S' + (lastId + 1);

    speakers.push(speaker);

    this.onChangeSpeakers(speakers);
  }

  onDeleteSpeaker(speakerId) {
    const speakers = [...this.props.speakers];

    const index = speakers.findIndex((x) => x.id === speakerId);
    if (index === -1) {
      return;
    }

    speakers.splice(index, 1);

    this.onChangeSpeakers(speakers);
  }

  onConfirmDeleteSpeaker(speaker) {
    const speakerName = this.getSpeakerName(speaker);
    const popup = {
      displayed: true,
      title: {
        fr: `Supprimer ${speakerName} ?`,
        en: `Delete ${speakerName}?`,
      },
      text: {
        fr: `Voulez-vous supprimer le speaker ${speakerName} ?`,
        en: `Do you want to remove speaker ${speakerName}?`,
      },
      buttons: [
        {
          text: {
            fr: 'Oui',
            en: 'Yes',
          },
          onclick: () => {
            this.onDeleteSpeaker(speaker.id);
            this.onClosePopup();
          },
        },
        {
          text: {
            fr: 'Non',
            en: 'No',
          },
          onclick: () => {
            this.onClosePopup();
          },
        },
      ],
      showIcon: true,
      icon: null,
    };

    this.setState({ popup });
  }

  onChangeSpeakers(updatedSpeakers) {
    console.log(updatedSpeakers);
    const speakers = orderBy(updatedSpeakers, ['firstName', 'name']);
    this.props.onChangeSpeakers(speakers);

    if (this.state.speakerForm.displayed) {
      this.setState({
        speakerForm: {
          displayed: false,
          title: null,
          speaker: null,
        },
      });
    }
  }

  onClickCommonSpeakerForm(event) {
    switch (event.name) {
      case 'back':
        this.setState({
          speakerForm: {
            displayed: false,
            title: null,
            speaker: null,
          },
        });
        break;
      case 'submit':
        const speaker = event.value;

        if (speaker.id) {
          const updatedSpeakers = this.props.speakers.map((s) => {
            return s.id === speaker.id ? speaker : s;
          });

          this.onChangeSpeakers(updatedSpeakers);
        } else {
          this.onAddSpeaker(speaker);
        }

        break;
      default:
        return;
    }
  }

  onClickCommonMergeForm(event) {
    switch (event.name) {
      case 'back':
        this.setState({
          mergeForm: {
            displayed: false,
            title: null,
            speaker: null,
            speakers: [],
          },
        });
        break;
      case 'submit':
        this.setState({
          mergeForm: {
            displayed: false,
            title: null,
            speaker: null,
            speakers: [],
          },
        });

        const { speakerId, mergeSpeakerId } = event.value;

        const speaker = this.props.speakers.find((x) => x.id === speakerId);

        const speakerMerge = this.props.speakers.find(
          (x) => x.id === mergeSpeakerId
        );

        const speakerName = this.getSpeakerName(speaker);
        const mergeSpeakerName = this.getSpeakerName(speakerMerge);

        const popup = {
          displayed: true,
          title: {
            fr: `Fusionner ${speakerName} avec ${mergeSpeakerName} ?`,
            en: `Merge ${speakerName} with ${mergeSpeakerName}?`,
          },
          text: {
            fr: `Voulez-vous fusionner le speaker ${speakerName} avec le speaker ${mergeSpeakerName} ?`,
            en: `Do you want to merge speaker ${speakerName} with speaker ${mergeSpeakerName}?`,
          },
          buttons: [
            {
              text: {
                fr: 'Oui',
                en: 'Yes',
              },
              onclick: () => {
                if (this.props.onMergeSpeaker){
                  this.props.onMergeSpeaker(speakerId, mergeSpeakerId);
                }
                this.onClosePopup();
              },
            },
            {
              text: {
                fr: 'Non',
                en: 'No',
              },
              onclick: () => {
                this.onClosePopup();
              },
            },
          ],
          showIcon: true,
          icon: null,
        };

        this.setState({ popup });

        break;
      default:
        return;
    }
  }

  onIdentifySpeakerDialoguesClick(speaker) {
    if (this.props.onIdentifySpeakerDialoguesClick) {
      this.props.onIdentifySpeakerDialoguesClick(speaker);
    }
  }

  onClosePopup() {
    this.setState({
      popup: {
        display: false,
        title: '',
        text: '',
        buttons: [],
        showIcon: false,
        icon: null,
      },
    });
  }

  getSpeakerName(speaker) {
    const names = [];

    if (speaker.firstname) {
      names.push(speaker.firstname);
    }

    if (speaker.name) {
      names.push(speaker.name);
    }

    return names.join(' ');
  }

  render() {
    const lang = this.context.language;

    const windows = [];

    if (this.state.speakerForm.displayed) {
      windows.push(
        <CommonSpeakerForm
          key={'speakerForm'}
          ref={this.speakerFormRef}
          title={this.state.speakerForm.title}
          speaker={this.state.speakerForm.speaker}
          onButton={this.onClickCommonSpeakerForm}
          display={this.state.speakerForm.displayed}
        ></CommonSpeakerForm>
      );
    }

    if (this.state.mergeForm.displayed) {
      windows.push(
        <CommonMergeSpeakerForm
          key={'mergeForm'}
          ref={this.mergeFormRef}
          title={this.state.mergeForm.title}
          speaker={this.state.mergeForm.speaker}
          speakers={this.state.mergeForm.speakers}
          display={this.state.mergeForm.displayed}
          onButton={this.onClickCommonMergeForm}
        ></CommonMergeSpeakerForm>
      );
    }

    if (this.state.popup.displayed) {
      windows.push(
        <SimplePopup
          key={'popup'}
          display={this.state.popup.displayed}
          title={this.state.popup.title}
          text={this.state.popup.text}
          onCancel={this.onClosePopup}
          buttons={this.state.popup.buttons}
          showIcon={this.state.popup.showIcon}
          icon={this.state.popup.icon}
        ></SimplePopup>
      );
    }

    return (
      <div className="speakers" role="list" id="speakersDiv">
        
        <div className="add">
          <Button
            button={true}
            image={imgAdd}
            tooltip={{
              fr: 'Ajouter un nouveau speaker',
              en: `Add a new speaker`,
            }}
            disable={false}
            onClick={this.onShowAddSpeakerFromDialog}
            height={12}
            width={12}
          />
        </div>

        <div className="list" style={{
            maxHeight: (this.state.height - 50) + 'px',
            overflowX: 'hidden',
            overflowY: 'auto',
          }}>
         

          {this.props.speakerIdsOrderByAppearance.map((id, index) => {
            const speaker = this.props.speakers.find((x) => x.id === id);
            if (!speaker) {
              return <></>;
            }

            const speakerName = this.getSpeakerName(speaker);

            return (
              <div className="speaker" role="listitem" key={`speaker_${index}`}>
                <div className="picture">
                  <Picture value={speaker.picture}></Picture>
                </div>
                <div className="info">
                  <p className="name">
                    {speakerName}
                    {speaker.gender ? ` (${speaker.gender})` : ''}
                  </p>
                  <p>{speaker.job}</p>
                  <div className="row">
                    <Color colorName={speaker.color} lang={lang} />
                    <div className="actions">
                      <Button
                        button={true}
                        image={imgEdit}
                        tooltip={{
                          fr: `Modifier ${speakerName}`,
                          en: `Edit ${speakerName}`,
                        }}
                        disable={false}
                        onClick={() => this.onShowEditSpeakerFormDialog(speaker)}
                        height={12}
                        width={12}
                      />
                      <Button
                        button={true}
                        image={imgDelete}
                        tooltip={{
                          fr: `Supprimer ${speakerName}`,
                          en: `Delete ${speakerName}`,
                        }}
                        disable={false}
                        onClick={() => this.onConfirmDeleteSpeaker(speaker)}
                        height={12}
                        width={12}
                      />
                      <Button
                          button={true}
                          image={imgEye}
                          tooltip={{
                            fr: `Identifier les répliques du ${speakerName}`,
                            en: `Identify ${speakerName}'s dialogues`,
                          }}
                          display={this.props.canIdentifySpeakers}
                          disable={false}
                          onClick={() => this.onIdentifySpeakerDialoguesClick(speaker)}
                          height={12}
                          width={12}
                        />
                        <Button
                          button={true}
                          image={imgMerge}
                          tooltip={{
                            fr: `Fusionner ${speakerName}`,
                            en: `Merge ${speakerName}`,
                          }}
                          display={this.props.canMerge ?? true}
                          disable={false}
                          onClick={() => this.onShowMergeSpeakerFormDialog(speaker)}
                          height={12}
                          width={12}
                        />
                      </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {windows}
      </div>
    );
  }
}

function Picture({ value }) {
  if (!value) {
    return <></>;
  }

  return <img alt="" src={value} />;
}

function Color({ colorName, lang }) {
  const color = getColorByShortcut(colorName);

  if (!color) {
    return <></>;
  }

  return (
    <div className="color">
      <span className="sr-only">{lang === 'fr' ? color.fr : color.en}</span>
      <div className="picto" style={{ backgroundColor: color.hex }}></div>
    </div>
  );
}

SpeakersList.defaultProps = {
  speakers: [],
  type: 'view',
};

export default SpeakersList;